import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// general setting.json
import s from '../../assets/styles/style.sass';
import s2 from './Header.sass';
import orderingHeaderStyle from './OrderingHeaderStyle.sass';

import { returnLocaleText } from '../../service/util';
import HeaderMenuRight from './Header/MenuRight';
import navLog from '../../assets/img/nav_logo.png';
import navLog2 from '../../assets/img/nav_logo@2x.png';

class OrderingHeader extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      // delay to show header
      isShowheader: false,
      modelDataSetting: require(`../../assets/json/default/setting/general/setting.json`),
      modelDataDefaultLocale: require(`../../assets/json/default/setting/general/locale.json`),
      modelDataLocale: require(`../../assets/json/${lang}/${fileLang}setting/general/locale.json`),
    };
  }

  componentDidMount() {
    this.setIsShowHeader();
  }

  setIsShowHeader() {
    this.setState({ isShowheader: true });
  }

  render() {
    return (
      <header
        className={`${s.order} ${s2.headerFontFamily}`}
        style={this.state.isShowheader ? {} : { visibility: 'hidden' }}
      >
        <div className={`${s.container}`}>
          <div className={`${s.headerLogo}`}>
            <a href="/">
              <img alt="GoGoVan" srcSet={`${navLog} 1x, ${navLog2} 2x`} />
            </a>
          </div>
          <nav
            className={`${orderingHeaderStyle.headerLeft} ${s.headerMenuLeft} `}
          >
            <ul>
              {this.state.modelDataSetting.ordering_header.left_menu.map(i => {
                const page = i.replace('ordering_', '');
                if (this.props.filename.toUpperCase() === page.toUpperCase()) {
                  return (
                    <a
                      href={page}
                      key={page}
                      className={`${s.headerMenuLeftItem} ${
                        s.headerMenuLeftBar
                      } ${s.active} ${s.resetFontsize}`}
                    >
                      {returnLocaleText(
                        this.state.modelDataLocale[`page_${i}`],
                        this.state.modelDataDefaultLocale[`page_${i}`],
                      ).toUpperCase()}
                    </a>
                  );
                }
                return (
                  <a
                    href={page}
                    key={page}
                    className={`${s.headerMenuLeftItem} ${
                      s.headerMenuLeftBar
                    } ${s.resetFontsize}`}
                  >
                    {returnLocaleText(
                      this.state.modelDataLocale[`page_${i}`],
                      this.state.modelDataDefaultLocale[`page_${i}`],
                    ).toUpperCase()}
                  </a>
                );
              })}
            </ul>
          </nav>
          <HeaderMenuRight />
        </div>
      </header>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
});
export default connect(mapState)(
  withStyles(bootstrap, s, orderingHeaderStyle)(OrderingHeader),
);



// WEBPACK FOOTER //
// ./src/components/Header/OrderingHeader.js